import React from 'react'
import {findDOMNode} from "react-dom"

import UserIcon from "../../../../core/gd-components/icons/user/user"
import formatTime from "../../../../core/gd/format/time"
import formatDate from "../../../../core/gd/format/date"
import MoreMenu from "../../components/more-menu/more-menu"
import PopupMenuButton from "../../../../core/gd-components/popover-menu/popup-menu-button/popup-menu-button"
import {ChatType, EVENT_BUS_SESSION_CHATS_CHANGE, OpenChat} from "../../../../core/model2/chat/chat/const"
import ChatController from "./controller/chat-controller"
import Chat from "../../../../core/model2/chat/chat/chat"
import NavigationSection from "../../../../core/model2/navigation/navigation-section"
import ProjectIconUI5 from "../../../../core/gd-components/icons/project/project-icon-ui5";
import {ItemIconSize} from "../../../../core/gd-components/icons/@const";

type Props = {
    chatId              : ID
    chat                : Chat
    showPin             : boolean
    showAvatar          : boolean | undefined
    customChats         : boolean | undefined
    navigationSection   : NavigationSection
}

export default class NavigationMenuItemChat extends React.Component<Props> {

    public controller : ChatController

    constructor(props: Props) {
        super(props)

        this.controller = new ChatController(this.props.chatId)
    }

    componentDidMount() {
        gd.bus.subscribe(EVENT_BUS_SESSION_CHATS_CHANGE, this, this.onChatUpdate)
    }

    componentWillUnmount() {
        gd.bus.unsubscribe(this)
    }

    onChatUpdate = (data: any) => {
        if (this.props.chatId === data?.chatId) {
            this.forceUpdate()
        }
    }

    onClick = () => {
        if (this.props.navigationSection) {
            this.props.navigationSection.defaultAppUrl = this.props.chat.url
        }

        const openChat = gd.user.settings.views.chat.openChatMenu

        switch (this.props.chat.systemType) {
            case ChatType.PROJECT_DISCUSSION    :
                if(this.props.customChats){
                    const url = 'p/{0}/discussion/{1}'.f(this.props.chat.projectId, openChat === OpenChat.WINDOW ? '' : this.props.chatId)
                    gd.setUrl(url, true)
                    gd.bus.triggerEvent("app-discussion:openDiscussion", {chatId: this.props.chatId})
                }else{
                    gd.goTo("chat/{0}".f(this.props.chatId))
                }
                break

            case ChatType.USER                  :
            case ChatType.GROUP                 :
            default                             : {
                gd.goTo("chat/{0}".f(this.props.chatId))
            }
        }

        gd.bus.triggerEvent("menu-chat-list:update")
    }

    renderIcon() {
        let res

        switch (this.props.chat.systemType) {
            case ChatType.GROUP             :
                res = <div className="chat-icon group">
                        <div className="i5-users ui5-color-white fs-14"></div>
                      </div>
                break

            case ChatType.PROJECT_DISCUSSION:
                const project = gd.session.projects.get(this.props.chat.projectId)
                res =  (
                    <div className={Classes("chat-icon", project ? 'gd-c-'+project.color : '')}>
                        <ProjectIconUI5 className   = "ui5-color-white"
                                        size        = {ItemIconSize.SIZE_14}
                                        projectId   = {this.props.chat.projectId}
                                        colorize    = {false} />
                    </div>
                )
                break

            case ChatType.USER:

                const companionId = this.props.chat.user1Id === gd.session.me.id ? this.props.chat.user2Id : this.props.chat.user1Id
                res =  <UserIcon className="chat-icon" userId={companionId!} size="26" />
                break
        }

        return res
    }

    renderName() {
        let res

        switch (this.props.chat.systemType) {
            case ChatType.GROUP             :
            case ChatType.PROJECT_DISCUSSION:
                res = <div className="name">{this.props.chat.name}</div>
                break

            case ChatType.USER              :
                const companionId = this.props.chat.user1Id === gd.session.me.id ? this.props.chat.user2Id : this.props.chat.user1Id
                res =  <div className="name">{gd.session.users.get(companionId!)?.name}</div>
                break
        }

        return res
    }

    /*renderTime() {
        const timeMoment = moment(this.props.chat.momentLastUpdated)
        let res;
        if (timeMoment.isSame(moment(),'day')) {
            res = "Today, " + timeMoment.format(gd.session.me.formatSettings.time)
        } else if (timeMoment.isSame(moment().subtract(1,'day'),'day')) {
            res = "Yesterday, " + timeMoment.format(gd.session.me.formatSettings.time)
        } else {
            res = formatDate(timeMoment)
        }
        return <div className="date">{res}</div>
    }*/

    renderTimeShort() {
        const timeMoment = moment(this.props.chat.momentLastUpdated);
        let res
        if (timeMoment.isSame(moment(),'day')) {
            res = formatTime(timeMoment)
        } else {
            res = formatDate(timeMoment)
        }
        return <div className="ui5-txt-not-important-arial date-new m-r-10">{res}</div>
    }

    onPopoverToggle = (newValue: any) => {
        gd.utils.Dom.toggleClass(findDOMNode(this), 'is-hover', newValue)
    }

    isSelected = ()=>{
        const currentChat = this.props.navigationSection.navigationLocalSettings._sectionsLatestAppUrl?.chats?.split("/")[1];
        return currentChat === this.props.chat.id
    }

    render() {
        const classes = Classes("item chat2", {
            "with-counter"  : this.props.chat.newMessages > 0,
            "selected"      : this.isSelected()
        })

        return (
            <div className={classes} onClick={this.onClick}>
                {this.props.showAvatar && this.renderIcon()}

                <div className="chat-row">
                    <div className="chat-row-top">
                        {this.renderName()}
                        <div className="right-controls m-l-10">
                            {this.renderTimeShort()}
                            <PopupMenuButton className           = "more ui5-ico-more s20"
                                             attachment          = 'top left'
                                             targetAttachment    = 'top right'
                                             offset              = "18 0"
                                             menuComponent       = {MoreMenu}
                                             menuParams          = {{
                                                 chatType   : this.props.chat.systemType,
                                                 onRename   : ()=>{this.controller.renameChat(this.props.chat)},
                                                 onLeave    : ()=>{this.controller.leaveChat(this.props.chat.systemType)},
                                                 onDelete   : ()=>{this.controller.deleteChat(this.props.chat.systemType)},

                                             }}
                                             onTogglePopover      = {this.onPopoverToggle}/>
                        </div>

                    </div>

                    <div className="chat-row-bottom">
                        <div className="last-message">{this.props.chat.lastMessage}</div>
                        {this.props.chat.newMessages > 0 && <div className="counter"><span>{this.props.chat.newMessages}</span></div>}
                    </div>
                </div>
            </div>
        )
    }
}
